import React from 'react';
import { motion } from 'framer-motion';

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  enter: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
};

function PrivatlivspolitikPage() {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="enter"
      exit="exit"
      transition={{ duration: 0.4 }}
    >
      <section className="section" style={{ paddingTop: 'calc(var(--header-height) + var(--space-16))' }}>
        <div className="container privacy-policy">
          <motion.div
            className="section__header"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="section__title">Privatlivspolitik for Core4it</h1>
          </motion.div>

          <motion.div
            className="privacy-policy__content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h2 className="privacy-policy__heading">1. Dataansvarlig</h2>
            <p>
              Vi er dataansvarlige for behandlingen af de personoplysninger, som vi modtager om vores kunder og besøgende.
            </p>
            <p>
              <strong>Kontaktoplysninger:</strong><br />
              Core4it<br />
              Nordre frihavnsgade 84 <br />
              2100 københavn ø<br />
              CVR-nr.: 46251377
            </p>
            <p>
              Hvis du har spørgsmål til vores behandling af dine oplysninger, kan du altid kontakte os på: core4it2026@gmail.com.
            </p>

            <h2 className="privacy-policy__heading">2. Behandlingsaktiviteter</h2>

            <h3 className="privacy-policy__subheading">Besøg på hjemmesiden (Ingen cookies)</h3>
            <p>
              Vi anvender ikke cookies på vores hjemmeside. Vi tracker ikke din adfærd, og vi bruger ikke statistikværktøjer som Google Analytics. Du kan derfor færdes anonymt på siden.
            </p>

            <h3 className="privacy-policy__subheading">Kontaktformular og korrespondance</h3>
            <p>
              Når du kontakter os via vores kontaktformular eller sender os en e-mail, behandler vi de oplysninger, du indtaster (typisk navn, e-mail og din besked).
            </p>
            <p>
              <strong>Formål:</strong> At kunne besvare din henvendelse og yde rådgivning.<br />
              <strong>Hjemmel:</strong> Databeskyttelsesforordningens artikel 6, stk. 1, litra f (legitim interesse i at besvare henvendelser).<br />
              <strong>Sletning:</strong> Vi sletter din henvendelse, når den er færdigbehandlet, medmindre du bliver kunde hos os.
            </p>

            <h3 className="privacy-policy__subheading">Kundeadministration</h3>
            <p>
              Hvis du bliver kunde hos os, behandler vi de oplysninger, der er nødvendige for at levere vores ydelser og fakturere dig (navn, adresse, CVR-nr., e-mail og betalingsoplysninger).
            </p>
            <p>
              <strong>Hjemmel:</strong> Databeskyttelsesforordningens artikel 6, stk. 1, litra b (opfyldelse af kontrakt).<br />
              <strong>Sletning:</strong> Vi gemmer dine oplysninger, så længe kundeforholdet eksisterer, og herefter i 5 år pga. bogføringsloven.
            </p>

            <h2 className="privacy-policy__heading">3. Databehandlere</h2>
            <p>
              For at kunne drive vores virksomhed benytter vi os af følgende leverandører, som behandler data på vores vegne:
            </p>
            <ul className="privacy-policy__list">
              <li><strong>Netlify:</strong> Til hosting af hjemmesiden og teknisk håndtering af kontaktformularen.</li>
              <li><strong>Google Ireland Limited:</strong> Til håndtering af vores e-mail-korrespondance via Gmail.</li>
            </ul>

            <h2 className="privacy-policy__heading">4. Overførsel til USA</h2>
            <p>
              Da vi hoster vores løsning via Netlify, kan der ske en overførsel af tekniske data (som din besked i formularen) til servere i USA. Vi sikrer os, at dette sker lovligt, da Netlify følger de godkendte rammer for databeskyttelse (EU-U.S. Data Privacy Framework) eller bruger EU-Kommissionens standardkontrakter.
            </p>

            <h2 className="privacy-policy__heading">5. Dine rettigheder</h2>
            <p>Du har altid ret til at:</p>
            <ul className="privacy-policy__list">
              <li>Få indsigt i, hvilke data vi har om dig.</li>
              <li>Få rettet forkerte oplysninger.</li>
              <li>Få slettet dine data (i det omfang vi ikke er lovmæssigt forpligtet til at gemme dem til f.eks. bogføring).</li>
            </ul>
            <p>
              For at gøre brug af dine rettigheder skal du blot skrive til os på core4it2026@gmail.com.
            </p>

            <h2 className="privacy-policy__heading">6. Klageadgang</h2>
            <p>
              Du har ret til at indgive en klage til Datatilsynet, hvis du er utilfreds med vores behandling af dine data. Se mere på <a href="https://www.datatilsynet.dk" target="_blank" rel="noopener noreferrer" className="privacy-policy__link">www.datatilsynet.dk</a>.
            </p>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
}

export default PrivatlivspolitikPage;
